// @flow
import Resource from 'speed-js-core/src/api/NestedResource';

export default class VehicleNestedResource extends Resource {
    basePath: string = 'services/providers/providers/{parent}/vehicles/';

    objectPath: string = 'services/providers/providers/{parent}/vehicles/{ident}/';
}
